import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'altcha';
import App from './App.vue';
import { router } from './router';
import { i18n } from './i18n';
import { installGoogleTags } from './utils/gtag';

const app = createApp(App);
app.use(createPinia());
app.use(router);
installGoogleTags(router);
app.use(i18n);
app.mount('#app');
